import React from 'react';
import { Button, Form } from 'react-bootstrap'
function Feedback() {
    return (
        <div className="main-container">
            <h1 style={{color:"white" , marginTop:19 ,textAlign:"center", marginBottom:19}}>Feedback </h1>
            {/* <Form responsive style={{color:"grey",textAlign:"center"}} action="https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&source=mailto&su=Feedback%20of%20Weather%20Forecasting%20PWA&to=variya.rudrax@gmail.com">
                <Form.Group controlId="formBasicEmail">
                    <Form.Label>Email address :</Form.Label>
                    <Form.Control  type="email"  />
                    <Form.Text className="text-muted" >
                        We'll never share your email with anyone else.
                    </Form.Text>
                </Form.Group>
                <Form.Group controlId="exampleForm.ControlTextarea1">
                    <Form.Label>Your Feedback :</Form.Label>
                    <Form.Control  as="textarea" rows="3" />
                    <Form.Text className="text-muted" >
                        Your feedback is Important to us 
                    </Form.Text>
                </Form.Group> */}

                <Button variant="primary" type="submit">
                <a href="https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&source=mailto&su=Feedback%20of%20Weather%20Forecasting%20PWA&to=variya.rudrax@gmail.com" style={{color:"white"}}>Send Mail</a>
            </Button>
            {/* </Form> */}


        </div>
    );
}


export default Feedback;